import { GetStaticPropsContext } from 'next'
import Sitemap from '../../components/Sitemap'
import { getSitemapPage } from '../../api/sitemap'
import getLanguageFromLocale from '../../utils/getLanguageFromLocale'
import { TENANTS } from '../../constants/global'
import { withStaticPropsMocks } from '../../playwright/utils/withMockingProps'
import { SITEMAP_TYPES, SitemapLink } from '../../types/sitemap'
import { buildLinkTitle } from '../../utils/sitemap'

export const getStaticProps = withStaticPropsMocks(async (context: GetStaticPropsContext) => {
  try {
    const { locale = 'uk', params } = context

    const lang = getLanguageFromLocale(locale)
    const sitemapParams = (params?.sitemap as string[]) || []

    const pathSegments = sitemapParams.filter((param) => !param.startsWith('page-'))

    if (sitemapParams.includes('page-1')) {
      return {
        redirect: {
          destination: `/${locale}/sitemap/${pathSegments.join('/')}`,
          permanent: false
        }
      }
    }

    const currentSlug =
      (pathSegments.find((param) => Object.values(SITEMAP_TYPES).includes(param as SITEMAP_TYPES)) as SITEMAP_TYPES) ||
      SITEMAP_TYPES.SPECIALISTS
    const currentSorting = pathSegments.find((param) => param?.length === 1 || param === 'other') || null
    const currentSubSlug = pathSegments.find((param) => param !== currentSlug && param !== currentSorting) || null
    const currentPage = Number(sitemapParams.find((param) => param.startsWith('page-'))?.replace('page-', '') || '1')

    const sitemapPage = await getSitemapPage({
      locale,
      page: currentPage,
      limit: 300,
      slug: currentSubSlug || currentSlug,
      sorting: currentSorting
    })

    const data = sitemapPage.data || []

    if (!data.length) {
      return { notFound: true }
    }

    const content = data.map((item: SitemapLink) => {
      let url =
        currentSlug === SITEMAP_TYPES.SPECIALTIES_CONDITIONS_PROCEDURES && !currentSubSlug
          ? `/${locale}/sitemap/${SITEMAP_TYPES.SPECIALTIES_CONDITIONS_PROCEDURES}/${item.specialty?.slug}`
          : item.url

      if (locale === TENANTS.AR_UAE) {
        url = url?.replace(TENANTS.EN_UAE, TENANTS.AR_UAE)
      }

      return {
        url,
        title:
          buildLinkTitle({
            item,
            slug: currentSubSlug || currentSlug,
            lang
          }) || item.url
      }
    })

    const currentKeyword = (currentSubSlug && data[0]?.specialty?.name?.[lang]) || null

    if (locale === TENANTS.AR_UAE) {
      sitemapPage.sitemaps = sitemapPage.sitemaps.filter(
        (type: string) => type !== SITEMAP_TYPES.SPECIALTIES_CONDITIONS_PROCEDURES
      )
    }

    if (!sitemapPage.sitemaps.includes(currentSlug)) {
      return {
        notFound: true
      }
    }

    return {
      props: {
        types: sitemapPage.sitemaps,
        sorting: sitemapPage.availableSorting,
        content,
        currentType: currentSlug,
        currentSubType: currentSubSlug,
        currentSorting,
        currentKeyword,
        pagination: sitemapPage.pagination
      }
    }
  } catch (error) {
    console.error('Sitemap load error:', error)
    return { notFound: true }
  }
}, 'sitemap/:slug')

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking'
  }
}

export default Sitemap
